import IBaseComponent from '@components/FormFlow/Interfaces/Base/IBaseComponent';
import IQRCodeComponent from '@components/FormFlow/Interfaces/FormflowComponents/IQRCodeComponent';
import { LocalStorageKeys } from '@containers/App';
import { ComponentType } from '@interfaces/component-type';
import IPagination from '@interfaces/IPagination';
import { ITarget } from '@interfaces/ITargets';
import TargetService from '@services/TargetService';
import I18n from '@src/i18n';
import styled from '@src/styled-components';
import { Select } from 'antd';
import React from 'react';

import ProcessContext from '../ProcessContext';

const Option = Select.Option;
interface IQRCODETaskComponentStateType {
  instructionTitle: string;
  targets: ITarget[];
  offset?: string,
  targetId: string,
  description?: string;


};

export class QRCodeComponent implements IQRCodeComponent {
    id: string;
    type: ComponentType;
    title: string;
    description?: string;
    targetId: string;
    constructor(id: string = '') {
      this.id = id;
      this.type = ComponentType.QRCODE;
      this.title = '';
      this.targetId = '';

      return this;
    }
  }


const _targetService: TargetService = new TargetService();
export default class QRCodeComponentProcess extends React.Component<IQRCodeComponent, IQRCODETaskComponentStateType> {
  private idUnit: string = '';

  constructor(props: IQRCodeComponent) {
    super(props);
    this.idUnit = String(localStorage.getItem(LocalStorageKeys.ACTIVE_UNIT_ID))
    this.state = {
        instructionTitle: this.props.title || '',
        targetId: this.props.targetId ? this.props.targetId : '',
        targets: [],
        description: this.props.description || undefined,
    };
  }

  componentDidMount = async () => {
    this.getTargets(true);
  }

  onSave(updateFormflowWithComponent: (component: IBaseComponent) => void) {
    

    const newQRCodeDataComponent: any = {

      targetId: this.state.targetId,
    }
    updateFormflowWithComponent(newQRCodeDataComponent);
  }

  async getTargets(reset: boolean) {

    if (reset) {
      this.setState({
        offset: undefined
      });
    }
    try {
      const response: IPagination<ITarget> = await _targetService.paging({
        unit: this.idUnit,
        to: undefined,
        from: undefined,
        limit: 100,
        offset: this.state.offset
      });
      this.setState({ targets: response.items, offset: response.offset });
    } catch (e) {
      console.error(e)
    }
  }


  getOptionsTargets = () => {
    let options: JSX.Element[] = []
    for (const items of this.state.targets) {
      options.push(
        <Option key={items.id} value={items.id} >{items.name}</Option>
      )
    }
    return options;
  }
  
  
  handleTargetSelectChange = async (evt: any) => {    
    this.setState({ targetId: evt })
}
  render() {
    return (
      <div>
        <Wrapper>
            <>
              <div
                style={{ marginTop: '1rem', marginBottom: '0.5rem' }}
              >
                {I18n.l('formflow.components.QRCodeComponent.chooseTarget')}
              </div>
              <Select
                style={{ width: '100%' }}
                onChange={this.handleTargetSelectChange}
                defaultValue={this.state.targetId}
              >
                {this.getOptionsTargets()}
              </Select>
            </>
        </Wrapper>
      
        <ProcessContext.Consumer>
          {({ updateProcessComponent }) => (
            <>
              {this.onSave(updateProcessComponent)}
            </>
          )}
        </ProcessContext.Consumer>
      
      </div>
    );
  }
}

//#region CSS
const Wrapper = styled.div`
  margin-left: 25px;
`;

//#endregion
